// extracted by mini-css-extract-plugin
module.exports = {"registration":"LandingNewsletterTemplate_registration__EvKZK","rotation":"LandingNewsletterTemplate_rotation__PLwA_"};